// src/components/ServiceDownBanner.js
import React from 'react';
import { useServiceStatus } from '../context/ServiceStatusContext';
import { RefreshCw } from 'lucide-react'; // Import the refresh icon

const ServiceDownBanner = () => {
  const { serviceDown, refreshStatus, isLoading, lastChecked } = useServiceStatus();

  if (!serviceDown) return null;

  // Format the last checked time
  const formattedTime = lastChecked ? new Date(lastChecked).toLocaleTimeString() : 'unknown';

  return (
    <div className="bg-red-600 text-white p-3 text-center font-medium">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center">
        <div className="flex-1 mb-3 md:mb-0">
          <h2 className="text-lg font-bold mb-1">SERVICE TEMPORARILY DOWN</h2>
          <p>Service is temporarily down. We are working to restore our services. Please check back again soon.</p>
        </div>
        <div className="flex-shrink-0 flex items-center">
          <button 
            onClick={refreshStatus} 
            disabled={isLoading}
            className="ml-4 px-3 py-2 bg-white text-red-600 rounded hover:bg-gray-100 transition-colors flex items-center"
          >
            <RefreshCw size={16} className={`mr-1 ${isLoading ? 'animate-spin' : ''}`} />
            {isLoading ? 'Checking...' : 'Refresh Status'}
          </button>
          <span className="ml-3 text-xs opacity-70">Last checked: {formattedTime}</span>
        </div>
      </div>
    </div>
  );
};

export default ServiceDownBanner;